import React from 'react';

export default function ProgressBar({
  percent,
  barClassName = 'bg-ptcm-primary',
  heightClassName = 'h-2'
}) {
  const p = Math.max(0, Math.min(100, Number(percent) || 0));
  return (
    <div className={`w-full ${heightClassName} bg-ptcm-panel dark:bg-gray-800 rounded-full overflow-hidden`}>
      <div
        className={`${heightClassName} rounded-full transition-all ${barClassName}`}
        style={{ width: `${p}%` }}
      />
    </div>
  );
}

